import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetFlightsResultEffect } from './get-flights-result.effect';
import { getFlightsResultReducer } from './get-flights-result.reducer';
import { GET_FLIGHTS_RESULT_STORE_NAME, GetFlightsResultState } from './get-flights-result.state';

/** Token of the GetFlightsResult reducer */
export const GET_FLIGHTS_RESULT_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetFlightsResultState, Action>>(
  'Feature GetFlightsResult Reducer'
);

/** Provide default reducer for GetFlightsResult store */
export function getDefaultGetFlightsResultReducer() {
  return getFlightsResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_FLIGHTS_RESULT_STORE_NAME, GET_FLIGHTS_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetFlightsResultEffect]),
  ],
  providers: [{ provide: GET_FLIGHTS_RESULT_REDUCER_TOKEN, useFactory: getDefaultGetFlightsResultReducer }],
})
export class GetFlightsResultStoreModule {
  public static forRoot<T extends GetFlightsResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetFlightsResultStoreModule> {
    return {
      ngModule: GetFlightsResultStoreModule,
      providers: [{ provide: GET_FLIGHTS_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
